export default {
  IMG_AVATAR_AUTO: 'http://hawk-ce-oss.oss-cn-beijing.aliyuncs.com/cce-chuxue/user-20211115.png', // 默认头像 
  IMG_CRED_AUTO: 'http://hawk-ce-oss.oss-cn-beijing.aliyuncs.com/cce-chuxue/cred-20211115.png', // 证件照
  SIZE: 'mini',
  AREA_CODE: '360000',

  UKEY_URL: 'ws://localhost:9999/', // 老国标Websocket地址
  UKEY_TYPE_OLD: 1, // 老国标ukey
  UKEY_TYPE_NEW: 2, // 新国标ukey
  SEAL_DATA_TYPE_BASE64: 0,  // 签章数据类型 base64
  SEAL_DATA_TYPE_HEX: 1, // 签章数据类型 16进制编码
}


// WEBPACK FOOTER //
// ./src/setting.js